import React from "react";

const ComposerWindow = ()=>{
    const SSOURL = process.env.REACT_APP_SSOURL;
    return(
        <iframe src={`${SSOURL}/apps/composer/window`} style={{ width: "100%", height: "100%",border:"none" }} title="Dynamic Content"></iframe>
    )
}

export default ComposerWindow;